import request from "@/utils/request";

const fetchOwnerOrg = () => request
  .get("/api/settings/multi_user_plans/organisation", { token: true })
  .then(response => response);

const createOwnerOrg = () => {
  return request.post("/api/settings/multi_user_plans/organisation", { token: true });
};

export default {
  createOwnerOrg,
  fetchOwnerOrg
};
